import React from 'react';
import { Select } from '@material-ui/core';
import { AirportNameMap } from '../../../../../../services/ana/data/airportNameMap';
import { useTranslation } from 'react-i18next';

interface Props {
  value: string,
  // ターゲット空港一覧
  targetAirportCodeList: string[],
  onChange: (e: React.ChangeEvent<{
    name?: string | undefined;
    value: unknown;
  }>) => void,
  // 変更不可にするか（例：dummyValのプルダウンモード中は宮崎空港に固定）
  disabled?: boolean,
}

/** タクシー・ハイヤー予約画面の空港選択のセレクトボックスのコンポーネント。 */
export const SelectAirport: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation();
  return (
    <Select native value={props.value} onChange={props.onChange} disabled={props.disabled}>
      {props.targetAirportCodeList.map((airpotCode, idx)=>{
        const isNoMatch = t(`taxi:${airpotCode}`) === airpotCode;
        // airportNameListに定義されていない空港の場合には汎用リストから取得する
        // TODO: AirportNameMapは日本語のみなので、英語用のリストを作成する
        const airportLabel = isNoMatch? AirportNameMap[airpotCode]: t(`taxi:${airpotCode}`);
        return (
          <option value={airpotCode} key={idx}>{airportLabel}</option>
        )
      })}
    </Select>
  );
}

export default SelectAirport;
